import { createContextualCan } from '@casl/react'
import { createContext } from 'react'
import { AppAbility } from './types'

// This context is always undefined on the initial render
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const AbilityContext = createContext<AppAbility>(undefined!)
export const Can = createContextualCan(AbilityContext.Consumer)
